// Generated by ReScript, PLEASE EDIT WITH CARE


function shouldEnableTabbing(key) {
  return key === "Tab";
}

function applyTabbingClass(enabled) {
  var cl = document.body.classList;
  if (enabled) {
    cl.add("tabbing");
  } else {
    cl.remove("tabbing");
  }
}

function handleKeydown($$event) {
  if ($$event.key === "Tab") {
    return applyTabbingClass(true);
  }
  
}

function handleMouse(_event) {
  applyTabbingClass(false);
}

window.addEventListener("keydown", handleKeydown);

window.addEventListener("mousedown", handleMouse);

export {
  shouldEnableTabbing ,
  applyTabbingClass ,
  handleKeydown ,
  handleMouse ,
}
/*  Not a pure module */
